export const getUrlProject = () => {
    return getURLQuery('p');
};

export const getUrlLang = () => {
    return getURLQuery('lang');
};

export const getUrlQuery = (project_id = '', lang = '') => {
    let query = '';

    if (project_id && lang) {
        query = `?lang=${lang}&p=${project_id}`;
    } else if (project_id) {
        query = `?p=${project_id}`;
    } else if (lang) {
        query = `?lang=${lang}`;
    }

    return query;
};

const getURLQuery = query => {
    let url = new URL(window.location.href);
    return url.searchParams.has(query) ? url.searchParams.get(query) : '';
};
